import React from "react";
import { BetDetails } from "../../models/MyBetModel.tsx";
import { formatSelectedMlbPitchers } from "../../helpers/functions.tsx";

/** Row in bet details: only when the user selected one or more MLB pitchers. */
export function MlbPitchersDetailRow({
    pitchers,
}: {
    pitchers?: BetDetails["pitchers"] | null;
}) {
    const value = formatSelectedMlbPitchers(pitchers);
    if (!value) return null;

    return (
        <tr>
            <th className="title-table-pending">Pitchers</th>
            <td className="body-table-pending">{value}</td>
        </tr>
    );
}
